import Image from 'next/image';

/* Both assets are tight crops of the supplied Adzilio logo (transparent PNG),
   cut to their own ink bounds so they carry no baked-in whitespace. */

export function LogoLockup({ height = 30, priority = false, className = '' }) {
  return (
    <Image
      src="/adzilio-lockup.png"
      alt="Adzilio"
      width={497}
      height={168}
      priority={priority}
      className={className}
      style={{ height, width: 'auto', display: 'block' }}
    />
  );
}

export function LogoMark({ size = 26, className = '' }) {
  return (
    <Image
      src="/adzilio-mark.png"
      alt=""
      aria-hidden="true"
      width={187}
      height={170}
      className={className}
      style={{ height: size, width: 'auto', display: 'block' }}
    />
  );
}
